import {
  onboardingStepKindByKey,
  type OnboardingStepDto,
  type OnboardingStepKey,
  type OnboardingStepKind,
} from '@osteopro/shared';

/**
 * Écran où se fait chaque étape de la mise en route. Le numéro d'autorisation se saisit dans
 * Paramètres → Profil (pas Praticien) ; les rappels de rendez-vous vivent avec les courriels
 * patients, où mène aussi l'ancienne adresse `appointment-reminders`.
 */
export const ONBOARDING_STEP_PATHS: Readonly<Record<OnboardingStepKey, string>> = {
  cabinet_identity: '/settings/cabinet',
  practitioner_authorization: '/settings/profile',
  vat_regime: '/settings/billing',
  dunning: '/settings/dunning',
  iban: '/settings/billing',
  availability: '/settings/availability',
  consultation_types: '/settings/consultation-types',
  first_patient: '/patients?new=1',
  first_appointment: '/agenda?new=1',
  first_consultation: '/consultations/new',
  first_invoice: '/invoices?tab=invoices&new=1',
  wero: '/settings/buckaroo',
  doctena: '/settings/doctena',
  two_factor: '/settings/security',
  reminders: '/settings/patient-emails',
};

/** Obligatoires, puis premières actions, puis optionnelles. L'ordre du serveur est gardé dans chaque groupe. */
const KIND_ORDER: readonly OnboardingStepKind[] = ['required', 'starter', 'optional'];

export interface ChecklistGroup {
  kind: OnboardingStepKind;
  steps: OnboardingStepDto[];
}

export function checklistGroups(steps: readonly OnboardingStepDto[]): ChecklistGroup[] {
  return KIND_ORDER.flatMap((kind) => {
    const group = steps.filter((step) => onboardingStepKindByKey[step.key] === kind);
    return group.length === 0 ? [] : [{ kind, steps: group }];
  });
}

export interface ChecklistProgress {
  done: number;
  total: number;
  percent: number;
  complete: boolean;
}

export function checklistProgress(steps: readonly OnboardingStepDto[]): ChecklistProgress {
  const done = steps.filter((step) => step.done).length;
  const total = steps.length;
  return {
    done,
    total,
    percent: total === 0 ? 100 : Math.round((done / total) * 100),
    complete: done === total,
  };
}
